import { memo, useMemo } from 'react';
import MathText from '../MathText';

/**
 * Rendu preview/élève d'une question "Ordonner" — style Duolingo.
 * En haut : slots numérotés vides (zone réponse).
 * En bas : chips mélangées que l'élève tapera dans l'ordre.
 *
 * @param {Array} items - Les éléments dans le bon ordre
 */
const OrdonnerRenderer = memo(function OrdonnerRenderer({ items, light }) {
    // Mélanger les éléments pour simuler la vue élève
    const shuffledItems = useMemo(() => {
        if (!items || items.length === 0) return [];
        const shuffled = [...items];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }, [items]);

    if (!items || items.length === 0) return null;

    return (
        <div>
            {!light && <span className="text-[10px] font-semibold uppercase tracking-wider mb-2 block text-slate-400">Ordonner</span>}

            {/* Zone réponse — slots numérotés vides */}
            <div className={`flex flex-wrap gap-2 px-4 py-3 rounded-xl border border-dashed min-h-[48px] mb-3 ${
                light ? 'border-sky-300 bg-sky-50/50' : 'border-slate-500 bg-slate-800/50'
            }`}>
                {items.map((_, i) => (
                    <div
                        key={i}
                        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border min-w-[50px] ${
                            light ? 'border-sky-200 bg-white' : 'border-slate-600 bg-slate-700/30'
                        }`}
                    >
                        <span className={`text-[10px] font-bold ${light ? 'text-sky-400' : 'text-slate-500'}`}>{i + 1}.</span>
                        <span className={`text-sm ${light ? 'text-sky-300' : 'text-slate-600'}`}>—</span>
                    </div>
                ))}
            </div>

            {/* Chips mélangées — ce que l'élève verra */}
            <div className="flex flex-wrap gap-2 justify-center">
                {shuffledItems.map((item, i) => (
                    <span
                        key={i}
                        className={`px-4 py-2 rounded-xl border text-sm transition-all shadow-sm ${
                            light
                                ? 'border-sky-200 bg-white text-sky-800 font-medium'
                                : 'border-slate-500 bg-slate-700 text-slate-200 cursor-pointer hover:bg-slate-600 hover:border-slate-400'
                        }`}
                    >
                        <MathText>{item}</MathText>
                    </span>
                ))}
            </div>
        </div>
    );
});

export default OrdonnerRenderer;
